import { render, staticRenderFns } from "./SettingDesc.vue?vue&type=template&id=5ec96624&scoped=true"
import script from "./SettingDesc.vue?vue&type=script&lang=js"
export * from "./SettingDesc.vue?vue&type=script&lang=js"
import style0 from "./SettingDesc.vue?vue&type=style&index=0&id=5ec96624&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec96624",
  null
  
)

export default component.exports